export default __webpack_public_path__ + "static/media/component003-left.05f5ec99.png";